import CRMListItemWithAlertsContainer from "../CRMListItem/CRMListItemWithAlertsContainer";
import { CrmIntegrationListStatus } from "app/pages/sales-intelligence/sub-modules/management/types";
import { UnmatchedEmail } from "../../components/CrmIntegration/UnmatchedEmail";
import { InactiveCrmIntegration } from "../../components/CrmIntegration/InactiveCrmIntegration";

export const statusToViewMap = {
    [CrmIntegrationListStatus.NotIntegrated]: () => null,
    [CrmIntegrationListStatus.NotActive]: InactiveCrmIntegration,
    [CrmIntegrationListStatus.UnmatchedEmail]: UnmatchedEmail,
    [CrmIntegrationListStatus.SyncInProgress]: CRMListItemWithAlertsContainer,
    [CrmIntegrationListStatus.Active]: CRMListItemWithAlertsContainer,
};
